import { sequenceT } from 'fp-ts/lib/Apply';
import { constant, constFalse, pipe } from 'fp-ts/lib/function';
import { fromNullable, getOrElse, option } from 'fp-ts/lib/Option';

export const sequenceTOption = sequenceT(option);

export const getOrEmtyString = (s?: string): string => pipe(fromNullable(s), getOrElse(constant('')));

export const getOrFalse = getOrElse(constFalse);
